import { useMount } from './useMount.js';
import { useRafState } from './useRafState.js';
const getWindowDimensions = () => {
    if (typeof window !== 'undefined') {
        return {
            height: window.innerHeight,
            width: window.innerWidth,
        };
    }
    return {
        height: 0,
        width: 0,
    };
};
export const useWindowSize = () => {
    const [state, setState] = useRafState(getWindowDimensions());
    useMount(() => {
        if (typeof window === 'undefined') {
            return () => { };
        }
        // eslint-disable-next-line unicorn/consistent-function-scoping
        const handler = () => {
            setState(getWindowDimensions());
        };
        window?.addEventListener('resize', handler);
        return () => {
            window?.removeEventListener('resize', handler);
        };
    });
    return state;
};
//# sourceMappingURL=useWindowSize.js.map